module.exports = __webpack_public_path__ + "static/media/mediareport.d628532a.svg";